import OrdersPercentage from "../components/OrdersPercentage";
import MarketChanges from "../components/MarketChanges";
import Pairs from "../components/pairbox/Pairs";
import TradingChart from "../components/chart/TradingChart";
import LastTrades from "../components/LastTrades";
import TradingComp from "../components/tradespot/TradingComp";
import OrdersBook from "../components/orderbox/OrdersBook";
import OrdersHistory from "../components/orders-history/OrdersHistory";

export const layoutComps = {
    'order-pc': OrdersPercentage,
    'market-change': MarketChanges,
    'pairs': Pairs,
    'chart': TradingChart,
    'last-trades': LastTrades,
    'spot': TradingComp,
    'order-book': OrdersBook,
    'history': OrdersHistory
}

export const desktopDefaultLayout = [
    { i: 'order-pc', x: 0, y: 0, w: 6, h: 8 },
    { i: 'market-change', x: 6, y: 0, w: 18, h: 8 },
    { i: 'pairs', x: 0, y: 1, w: 6, h: 42 },
    { i: 'chart', x: 6, y: 1, w: 12, h: 36 },
    { i: 'last-trades', x: 0, y: 2, w: 6, h: 42 },
    { i: 'spot', x: 6, y: 2, w: 12, h: 48, zIndex: 100 },
    { i: 'order-book', x: 18, y: 1, w: 6, h: 84, zIndex: 102 },
    { i: 'history', x: 0, y: 3, w: 24, h: 52, zIndex: 100 }
]

export const enDesktopDefaultLayout = [
    { i: 'order-pc', x: 18, y: 0, w: 6, h: 8 },
    { i: 'market-change', x: 0, y: 0, w: 18, h: 8 },
    { i: 'pairs', x: 18, y: 1, w: 6, h: 42 },
    { i: 'chart', x: 6, y: 1, w: 12, h: 36 },
    { i: 'last-trades', x: 18, y: 2, w: 6, h: 42 },
    { i: 'spot', x: 6, y: 2, w: 12, h: 48, zIndex: 100 },
    { i: 'order-book', x: 0, y: 1, w: 6, h: 84, zIndex: 102 },
    { i: 'history', x: 0, y: 3, w: 24, h: 52, zIndex: 100 }
]

export const tabletDefaultLayout = [
    { i: 'market-change', x: 0, y: 0, w: 12, h: 8 },
    { i: 'chart', x: 0, y: 1, w: 8.5, h: 36 },
    { i: 'spot', x: 8.5, y: 1, w: 3.5, h: 118 },
    { i: 'last-trades', x: 0, y: 2, w: 4.25, h: 40 },
    { i: 'order-book', x: 4.25, y: 2, w: 4.25, h: 40 },
    { i: 'history', x: 0, y: 3, w: 8.5, h: 42 }
]

export const fullscreenLayout = (lang) => {
    return [
        {
            i: 'order-pc',
            x: lang === 'en' ? 18 : 0,
            y: 0, w: 6, h: 8
        },
        { i: 'chart', x: 0, y: 1, w: 16, h: 54 },
        { i: 'last-trades', x: 16, y: 1, w: 4, h: 48 },
        { i: 'order-book', x: 20, y: 1, w: 4, h: 48, zIndex: 102},
        { i: 'spot', x: 16, y: 2, w: 8, h: 48, zIndex: 100 },
        { i: 'history', x: 0, y: 2, w: 16, h: 42, zIndex: 100 },
        {
            i: 'market-change',
            x: lang === 'en' ? 0 : 6,
            y: 0, w: 18, h: 8,
            zIndex: 103
        }
    ]
}

export const fullscreenLayoutL = (lang) => ([
    {
        i: 'order-pc',
        x: lang === 'en' ? 18 : 0,
        y: 0, w: 6, h: 8
    },
    { i: 'chart', x: 0, y: 1, w: 14, h: 54 },
    { i: 'last-trades', x: 14, y: 1, w: 5, h: 54 },
    { i: 'order-book', x: 19, y: 1, w: 5, h: 54, zIndex: 102},
    { i: 'spot', x: 16, y: 2, w: 8, h: 48, zIndex: 100 },
    { i: 'history', x: 0, y: 2, w: 16, h: 48, zIndex: 100 },
    {
        i: 'market-change',
        x: lang === 'en' ? 0 : 6,
        y: 0, w: 18, h: 8,
        zIndex: 103
    }
])

export const initialToolboxItems = [
    { name: "order-pc", active: false, x: 18, y: 0, w: 6, h: 8, minW: 5, minH: 8 },
    { name: "market-change", active: false, x: 0, y: 0, w: 18, h: 8, minW: 13, minH: 8 },
    { name: "pairs", active: false, x: 18, y: 1, w: 6, h: 42, minW: 5, minH: 20 },
    { name: "chart", active: false, x: 6, y: 1, w: 12, h: 36, minW: 4, minH: 32 },
    { name: "spot", active: false, x: 6, y: 2, w: 12, h: 48, minW: 8, minH: 20, zIndex: 100 },
    { name: "history", active: false, x: 0, y: 3, w: 24, h: 52, minW: 18, minH: 24, zIndex: 100 },
    { name: "last-trades", active: false, x: 18, y: 2, w: 6, h: 42, minW: 5, minH: 20 },
    { name: "order-book", active: false, x: 0, y: 1, w: 6, h: 84, minW: 5, minH: 20, zIndex: 102 },
]
